import { baseNextjsUrl } from "@memorang/constants/src/urls";

const COPILOT_ENDPOINT = "/api/ai/copilot/openai";

// const COPILOT_AZURE_ENDPOINT = "/api/ai/copilot/azure";

export const COPILOT_URL = `${baseNextjsUrl}${COPILOT_ENDPOINT}`;
